module.exports = __webpack_public_path__ + "media/assets/main-visual-71040782d85e8583a8ac0f04d75ec6bc.png";